<template>
  <el-select
    size="mini"
    placeholder="Filtrar por servicio al cliente"
    v-bind:value="customerService"
    filterable
    clearable
    @change="handleChange"
    v-bind="$attrs"
  >
    <el-option
      v-for="(customerService, index) in customerServiceList"
      :key="index"
      :value="customerService.value"
      :label="customerService.label"
    >
      <el-avatar
        v-if="customerService.image"
        style="float: left"
        size="small"
        :src="customerService.image"
      ></el-avatar>
      <el-avatar
        v-else
        style="float: left"
        size="small"
        src="/static/images/avatar-2.jpg"
      ></el-avatar>
      <span style="padding-left: 3px; color: #8492a6; font-size: 12px"
        >{{ customerService.label.substring(0, 20) }}...</span
      >
    </el-option>
  </el-select>
</template>

<script>
// import { mapGetters } from "vuex";
export default {
  model: {
    prop: "customerService",
    event: "change"
  },
  props: {
    customerService: {
      type: Number,
      required: false,
      default: null
    },
    byUser: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    customerServiceList() {
      return this.$store.getters[
        "customer_services/getCustomerServiceByEmployeeId"
      ];
    }
  },
  methods: {
    getCustomerService(id) {
      return this.$store.getters[
        "customer_services/getCustomerServiceByEmployeeIdSelector"
      ](id);
    },
    handleChange(val) {
      this.$emit("change", val);
      const customerService = this.getCustomerService(val);
      this.$emit("selected-customer-service", customerService);
    }
  }
};
</script>
